var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgRightPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#img_right_person_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.476 10.401c-3.412 6.371-3.006 22.531 1.403 23.67 1.759.454 5.505-.658 9.317-2.96l-2.393 16.96h14.131L72.07 25.358c2.713-3.19 4.549-7.1 4.242-11.48C75.428 1.252 57.888 4.03 54.476 10.4z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.142 13.262c.14-.826.482-1.743.758-2.524.356-1.008.895-1.916 1.487-2.772a20.932 20.932 0 013.932-4.274c2.7-2.205 6.136-3.478 9.515-3.065a9.758 9.758 0 014.772 1.946c1.273.98 2.499 2.424 4.148 2.528 1.794.112 3.44-1.474 4.878-2.454 1.623-1.105 3.349-1.91 5.245-2.223C91.054-.1 94.04.975 96.23 3.587c2.33 2.778 4.023 6.853 2.493 10.535-.284.685-.65 1.262-1.175 1.74-.482.438-1.218.905-1.413 1.606-.207.744.412 1.705.653 2.377.344.963.626 1.974.526 3.02-.165 1.72-1.243 3.36-2.382 4.49-1.158 1.15-2.584 1.808-4.107 2.112-1.017.203-2.056.315-3.09.239-.513-.038-.966-.18-1.463-.294-.483-.11-.753.018-1.164.284-1.905 1.234-3.954 1.711-6.154 1.527-1.856-.154-3.996-.605-5.511-1.88-1.682-1.415-1.649-3.367-1.253-5.452-.42.208-1.58.337-.886-.493.275-.329.793-.463 1.146-.656.41-.225.827-.516 1.145-.883 1.287-1.483-.012-4.5-1.63-4.997-2.402-.739-2.94 2.665-4.655 3.545-.986.507-2.018-.185-2.756-.892-.99-.946-1.665-2.2-2.247-3.476-.48-1.051-.926-2.117-1.415-3.162-.228-.488-1.018-1.869-.622-2.42-1.72-.345-3.637.372-5.119 1.311-.613.389-1.08.817-1.406 1.502-.07.147-.223.584-.414.602-.356.033-.223-.403-.188-.61z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.644 97.029l-21.346 75.043-15.574 55.311h-11.36l16.55-130.354h31.73z",
    fill: "#1E2D3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.353 97.029c.494 38.678 2.177 59.774 2.696 63.288.518 3.514 8.356 25.869 23.515 67.066h-11.767c-19.298-39.521-30.071-61.876-32.318-67.066-2.248-5.19-9.183-26.286-19.629-63.288h37.503z",
    fill: "#2E4357"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.616 238l-.589-12.387h-12.365c-5.862 4.129-13.516 7.472-22.962 10.028V238h22.374l7.654-1.18V238h5.888z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.318 238l-.59-12.387H33.365c-5.862 4.129-13.516 7.472-22.962 10.028V238h22.374l7.654-1.18V238h5.888z",
    fill: "#030206"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.836 89.962l-12.304.049c7.597 24.569 11.699 37.605 12.304 39.108 1.363 3.382-1.52 8.534-2.753 11.302 4.015 1.8 3.587-4.866 8.653-2.505.462.215.913.448 1.357.69l.44.244c.292.164.581.331.868.497l.428.249c3.271 1.904 6.294 3.609 10.389 1.077.657-.406 1.377-1.934-.362-3.129-4.332-2.975-10.575-8.184-11.419-9.898-1.15-2.338-3.684-14.899-7.601-37.684zm-74.03-2.299l-16.68 16.301c-4.852 2.073-8.828 4.363-11.928 6.869-.697.842-1.456 2.456 1.824 1.734 3.28-.722 6.761-1.334 7.378-.265.616 1.068-1.2 2.705-.06 4.104.758.932 3.313-2.033 7.661-8.896l17.344-10.244-5.54-9.603z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.87 38.24l-5.09-.874C55.013 59.302 39.71 79.234 17.867 97.16l16.505 20.088c21.84-25.526 35.3-51.862 34.497-79.009z",
    fill: "#2F6779"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.064 102.337H45.73c10.503-25.584 15.755-47.318 15.755-65.2l13.675-2.041c10.748 17.316 13.783 38.637 15.905 67.241z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.55 35.096c-1.068.036-2.695.103-4.88.199l-3.305 9.46c-.35 11.535-2.39 34.78-6.124 69.736H89.96a181.326 181.326 0 01-.385 7.311h22.097c-3.306-37.358-15.376-66.26-36.212-86.707l-.01.01-.007-.01h-.892z",
    fill: "#2F6779"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.644 114.724l8.308-.001c.364-10.827-.288-21.2-1.955-31.12-.846 15.048-2.964 25.421-6.353 31.121z",
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.345 96.439l-14.654-6.825v6.825h14.654z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.307 20.194l17.701 5.747-4.005 12.347-5.355-1.739c-6.819-2.214-10.553-9.536-8.34-16.355z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "img_right_person_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h124v238H0z"
  })))));
}
export default SvgImgRightPerson;